import { AddBillSettingsModal } from "@features/AddBillSettingsModal/AddBillSettingsModal";
import { Button } from "@components/Button";
import { useModalActions } from "@store/modal/modal";

interface IAddBillButtonProps {
  children?: React.ReactNode;
  jointBillServiceId: number;
  serviceProviderId: number;
}

/**
 * Used for BannerMessage HTML element in HTML parser.
 */
export const AddBillButton: React.FC<IAddBillButtonProps> = (props) => {
  const { children, jointBillServiceId, serviceProviderId } = props;

  const { create } = useModalActions();

  const openAddBillModal = () => {
    if (jointBillServiceId === 0 || serviceProviderId === 0) {
      return;
    }

    create((modalProps) => (
      <AddBillSettingsModal
        {...modalProps}
        jointBillServiceId={jointBillServiceId}
        serviceProviderId={serviceProviderId}
      />
    ));
  };

  return (
    <Button variant="link" onClick={openAddBillModal}>
      {children}
    </Button>
  );
};
